import React from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CardMedia,
} from "@mui/material";
import { FaCheckCircle } from "react-icons/fa";
// import Section10BImg from "./section10B.png";
import Section10BImg from "../../img/CWTA.webp";
import { TbCircleNumber1Filled } from "react-icons/tb";

const Section10B = ({ ComponentData, index }) => {
  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        // border: "3px solid blue",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          // width: { xl: "72%", lg: "80%", md: "95%", sm: "94%" },
          width: { xl: "72%", lg: "89%", md: "89%", sm: "100%", xs: "92%" },
          alignItems: "center",
          justifyContent: { xl: "space-between", lg: "space-between" },
          // px: { xs: 2, md: 5 },
          py: 0,
          // border: "1px solid blue",
          height: "100%",
          // border: "1px solid red",
        }}
      >
        {/* Text Content */}
        <Stack
          sx={{
            maxWidth: { xs: "100%", md: "600px" },
            marginBottom: { xs: "24px", md: "0" },
            // border: "1px solid red",
            height: "100%",
          }}
        >
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 1,
           
              // border: "1px solid red",
              // alignItems: "center",
            }}
          >
            <Stack
              sx={{
                height: "60px",
                width: "60px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <TbCircleNumber1Filled size={40} />
            </Stack>
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                marginBottom: "16px",
                lineHeight: {
                  lg: "32px",
                  xl: "32px",
                  md: "32px",
                  xs: "24px",
                  sm: "24px",
                },
                // fontSize: "18px",
                fontSize: {
                  lg: "28px",
                  xl: "28px",
                  md: "28px",
                  xs: "20px",
                  sm: "20px",
                },
                fontFamily: "'Roboto', sans-serif",
                fontWeight: {
                  lg: 600,
                  xl: 600,
                  xs: 600,
                  sm: 600,
                },
                color: "rgb(0, 0, 0)",
                // paddingLeft: "12px",
                padding: "12px",
                // paddingRight: "12px",
                // border: "1px solid rgb(218 233 248)",
                borderRadius: "8px",
                display: {
                  xl: "flex",
                  lg: "flex",
                  md: "flex",
                  sm: "flex",
                  xs: "flex",
                },
              }}
            >
             
              {ComponentData[index]?.section10B?.card_head1}
            </Typography>
          </Stack>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "16px",
              lineHeight: {
                lg: "24px",
                xl: "24px",
                md: "20px",
                xs: "20px",
                sm: "20px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "20px",
                xl: "20px",
                md: "16px",
                xs: "16px",
                sm: "16px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 400,
                xl: 400,
                xs: 400,
                sm: 400,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: "12px",
              // paddingRight: "12px",
              // border: "1px solid rgb(218 233 248)",
              borderRadius: "8px",
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
              color: "gray",
            }}
          >
           
            {ComponentData[index]?.section10B?.card_head2}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "32px",
              lineHeight: {
                lg: "24px",
                xl: "24px",
                md: "20px",
                xs: "20px",
                sm: "20px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "20px",
                xl: "20px",
                md: "16px",
                xs: "16px",
                sm: "16px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 400,
                xl: 400,
                xs: 400,
                sm: 400,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: "12px",
              // paddingRight: "12px",
              // border: "1px solid rgb(218 233 248)",
              borderRadius: "8px",
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
              color: "gray",
            }}
          >
          
            {ComponentData[index]?.section10B?.card_head3}
          </Typography>
         
        </Stack>
        {/* Image Section */}
        <Box
          component="img"
          // src={Section10BImg}
          src={ComponentData[index]?.section10B?.card_image}
          alt="Section 10B"
          sx={{
            flex: 1,
            width: { xs: "100%", md: "80%", xl: "60%" },
            maxWidth: "500px",
            // border: "1px solid green",
          }}
        />
      </Box>
    </Stack>
  );
};

export default Section10B;
